import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../../errors/api-error-handler";
import { ImpexiumEmailAddUpdateInitialStateType, ImpexiumEmailAddUpdateResponse, ImpexiumEmailAddUpdateType } from "../../../models/impexium/impexium-email-add-update.model";
import ImpexiumEmailUser from "../../../services/impexium/impexium-email-add-update.service";

const initialState: ImpexiumEmailAddUpdateInitialStateType = {
  data: {} as ImpexiumEmailAddUpdateResponse,
  loading: false,
  error: undefined,
};

export const postImpexiumEmailAddUpdate = createAsyncThunk("ImpexiumEmailAddUpdate/post", async (request: ImpexiumEmailAddUpdateType) => {
  const service = new ImpexiumEmailUser();

  const response = await service.postEmailCreate(request);
  return response.data;
});

export const cleanImpexiumEmailAddUpdate = createAsyncThunk("ImpexiumEmailAddUpdate/clean", async () => {
  return;
});

const impexiumEmailAddUpdateSlice = createSlice({
  name: "impexiumEmailAddUpdate",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postImpexiumEmailAddUpdate.pending, (state) => {
        state.loading = true;
      })
      .addCase(postImpexiumEmailAddUpdate.fulfilled, (state, action) => {
        if (action.payload) {
          state.loading = false;
          state.data = action.payload as ImpexiumEmailAddUpdateResponse;
        }
      })
      .addCase(postImpexiumEmailAddUpdate.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = apiErrorHandler(Number(payload));
      }).addCase(cleanImpexiumEmailAddUpdate.fulfilled, (state) => {
        state.data = {} as ImpexiumEmailAddUpdateResponse;
        state.loading = false;
        state.error = undefined;
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default impexiumEmailAddUpdateSlice.reducer;
